<template>
  <transition name="fade">
    <div v-if="visible" class="success-modal-overlay" @click="close">
      <div class="success-modal-content" @click.stop>
        <div class="success-icon">
          <svg viewBox="0 0 52 52" width="52" height="52">
            <circle cx="26" cy="26" r="25" fill="#4CAF50"/>
            <path fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" d="M14 27l7.5 7.5L38 18"/>
          </svg>
        </div>
        <div class="success-message">{{ message }}</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SuccessModal',
  props: {
    message: {
      type: String,
      default: '操作成功'
    },
    duration: {
      type: Number,
      default: 2000
    }
  },
  data() {
    return {
      visible: false,
      timer: null
    }
  },
  methods: {
    show() {
      this.visible = true
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          this.close()
        }, this.duration)
      }
    },
    close() {
      this.visible = false
      this.$emit('close')
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }
}
</script>

<style scoped>
/* 成功提示弹窗样式 */
.success-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.success-modal-content {
  background: var(--card-bg);
  border-radius: 12px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 200px;
  animation: modalSlideIn 0.3s ease-out;
  transition: background-color 0.3s ease;
}

@keyframes modalSlideIn {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.success-icon {
  margin-bottom: 16px;
  animation: checkmarkPop 0.4s ease-out 0.2s both;
}

@keyframes checkmarkPop {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.success-message {
  font-size: 16px;
  color: var(--text-primary);
  text-align: center;
  font-weight: 500;
  transition: color 0.3s ease;
}

/* 过渡动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>

